<template>
  <div class="home">
    <div class="book-info">
      <div class="book-word">
        <div class="book-item-wrap">
          <div class="book-item-main">
            <img :src="list.cover" />
          </div>
        </div>
        <div class="book-introduction">
          <div class="book-name">{{ list.bookName }}</div>
          <div class="book-writer">{{ list.authorName }}</div>
          <div class="book-scal-wrap">
            <div class="book-scal">
              <div class="book-tag">
                <p>{{ list.subcateName }}</p>
                <p>{{ list.finish === 1 ? "完结" : "连载" }}</p>
                <p>{{ list.wordNum }}字</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="book-datail" v-if="list">
        <div class="datail-item">
          <div class="datail-num">{{ list.favorCount }}</div>
          <div class="datail-word">收藏数</div>
        </div>
        <div class="datail-item">
          <div class="datail-num">{{ list.clickCount }}</div>
          <div class="datail-word">点击数</div>
        </div>
        <div class="datail-item">
          <div class="datail-num">{{ list.readCount }}</div>
          <div class="datail-word">阅读数</div>
        </div>
        <div class="datail-item">
          <div class="datail-num">{{ list.commentCount }}</div>
          <div class="datail-word">评论数</div>
        </div>
      </div>
      <div class="book-introduction-wrap" v-if="list">
        {{ list.description }}
      </div>
      <div class="discuss-wrap" v-if="listB.length != 0" ref="chapterList">
        <div v-for="(item, index) in listB" :key="index">
          <a class="discuss-line" @click="toReadClick(item,index)">
            <span class="book-chapters">{{ item.chapterName }}</span>
          </a>
        </div>
        <!-- 加载更多提示 -->
        <div class="load-more" v-if="loading">加载中...</div>
        <div class="no-more" v-if="noMoreData">没有更多章节了</div>
      </div>
      <div class="no-chapters" v-if="listB.length === 0 && !loading">
        暂无章节
      </div>
    </div>
  </div>
</template>

<script>
// import { info, bookCatalog } from "@/api/info.js";
import axios from "axios";
export default {
  data() {
    return {
      active: 0,
      infoObj: {},
      bookFreeInfo: {},
      map: {},
      category: {},
      list: "",
      listB: [],
      // 分页相关数据
      pageNo: 1,
      pageSize: 30,
      loading: false,
      noMoreData: false,
      hasMore: true
    };
  },
  created() {
    this.infoPost(this.$route.query.id);
    this.bookCatalogPost(this.$route.query.id);
    if (this.$route.query.active != undefined) {
      this.active = Number(this.$route.query.active);
    }
  },
  mounted() {
    // 监听窗口滚动
    window.addEventListener('scroll', this.handleWindowScroll);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleWindowScroll);
  },
  methods: {
    infoPost(id) {
      this.http.getBookDetail({
        "bookId": id,
        "apiCode":"guosou",
      }).then((res) => {
        this.list = res.data.data;
      });
    },
    //章节
    bookCatalogPost(i, isLoadMore = false) {
      if (this.loading || this.noMoreData) return;
      
      this.loading = true;
      this.http.getChapterList({
        "bookId": i,
        "apiCode":"guosou",
        "pageNo": this.pageNo,
        "pageSize": this.pageSize,
      }).then((res) => {
        this.loading = false;
        
        if(res.data.status == 1){
          const newChapters = res.data.data || [];
          
          // 如果返回的数据为空数组，说明没有更多数据了
          if (newChapters.length === 0) {
            this.noMoreData = true;
            this.hasMore = false;
            // 如果是第一页就为空，显示暂无章节
            if (!isLoadMore && this.listB.length === 0) {
              this.listB = [];
            }
            return;
          }
          
          if (isLoadMore) {
            // 加载更多，追加数据
            this.listB = [...this.listB, ...newChapters];
          } else {
            // 首次加载
            this.listB = newChapters;
            localStorage.setItem('booklist', JSON.stringify(newChapters));
          }
          
          // 如果返回的数据少于请求的pageSize，说明没有更多数据了
          if (newChapters.length < this.pageSize) {
            this.noMoreData = true;
            this.hasMore = false;
          } else {
            this.hasMore = true;
          }
          
        } else if(res.data.status == 99){
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: 'warning'
          });
          setTimeout(() => {
            this.$router.push({
              path: "/mine",
            });
          }, 1500);
        } else if(res.data.status == 100){
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: 'warning'
          });
          setTimeout(() => {
            this.$router.push({
              path: "/vip",
            });
          }, 1500);
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    
    // 窗口滚动事件处理
    handleWindowScroll() {
      // 检查是否滚动到底部
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = window.innerHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      
      // 距离底部50px时触发加载
      if (scrollTop + windowHeight >= scrollHeight - 50) {
        this.loadMore();
      }
    },
    
    // 加载更多数据
    loadMore() {
      if (this.loading || !this.hasMore) return;
      
      this.pageNo++;
      this.bookCatalogPost(this.$route.query.id, true);
    },
    
    toReadClick(i,index){
      localStorage.setItem('bookindex', JSON.stringify(index));
      this.$router.push({
        path: "/toRead",
        query: {
          id: i.chapterId
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  background: red;
  min-height: 100vh;
}

.title {
  color: #333;
  font-weight: 400 !important;
  font-size: 14px !important;
}

.van-tabs__wrap {
  height: 40px !important;
}
.van-tabs__nav--card {
  border-right: 1px solid;
  border: none;
  margin: 0;
  height: 40px;
}
.van-tab--card {
  border: none;
  color: #666;
  border-bottom: 3px solid #00000000;
}
.van-tab--card.van-tab--active {
  color: #e2bd54;
  background: #fff;
  border-bottom: 2.5px solid #e2bd54 !important;
}
.van-tab--card:last-child {
  border-left: 1px solid #f2f2f2;
}
.book-info {
  background-color: #fff;
  min-height: 100vh;
}
.book-info .book-word {
  padding: 12px 0 7.5px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}
.book-info .book-word .book-item-wrap {
  position: relative;
  padding-left: 15%;
}
.book-info .book-word .book-item-wrap .book-item-main {
  position: relative;
  width: 66px;
  height: 90px;
  border-radius: 1.2px;
  overflow: hidden;
  -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.4);
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.4);
}
.book-info .book-word .book-item-wrap .book-item-main img {
  width: 100%;
  min-height: 100%;
  display: block;
}
.book-info .book-word .book-item-wrap .book-item-main .book-free {
  position: absolute;
  bottom: 1.5px;
  right: 1.5px;
  width: 15px;
  height: 15px;
  background-position: -408.5px -133px;
}
.book-info .book-word .book-item-wrap .book-num {
  width: 24px;
  height: 16.5px;
  position: absolute;
  top: 3px;
  left: -6px;
}
.book-info .book-word .book-introduction {
  flex: 1;
  -webkit-flex: 1;
  padding: 1.2px 51px 1.2px 15px;
  text-align: left;
}
.book-info .book-word .book-introduction .book-name {
  font-size: 18px;
  color: #323232;
}
.book-info .book-word .book-introduction .book-writer {
  font-size: 12px;
  padding: 5px 0;
  color: #969696;
}
.book-info .book-word .book-introduction .book-scal-wrap {
  position: relative;
  min-height: 36px;
}
.book-info .book-word .book-introduction .book-scal-wrap .book-scal {
  display: block;
  width: 200%;
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  position: absolute;
  left: 0;
  top: 0;
}
.book-info
  .book-word
  .book-introduction
  .book-scal-wrap
  .book-scal
  .renew-time {
  color: #ff6432;
  font-size: 19.5px;
  padding-bottom: 7.5px;
}
.book-info
  .book-word
  .book-introduction
  .book-scal-wrap
  .book-scal
  .renew-time
  .timing-wrap {
  color: #969696;
}
.book-info
  .book-word
  .book-introduction
  .book-scal-wrap
  .book-scal
  .renew-time
  .timing-wrap
  i {
  font-style: normal;
}
.book-info .book-word .book-introduction .book-scal-wrap .book-scal .book-tag {
  padding-top: 7.2px;
  overflow: hidden;
}
.book-info
  .book-word
  .book-introduction
  .book-scal-wrap
  .book-scal
  .book-tag
  p {
  float: left;
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 18px;
  margin-right: 12px;
  border: 1px solid #eebf64;
  color: #eebf64;
}
.book-info .book-datail {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  text-align: center;
  padding: 7.5px 0;
  border-bottom: 1px solid #f5f5f5;
}

.book-info .book-datail .datail-item {
  flex: 1;
  -webkit-flex: 1;
}

.book-info .book-datail .datail-item .datail-num {
  font-size: 12px;
  line-height: 14.4px;
  color: #eebf64;
}

.book-info .book-datail .datail-item .datail-word {
  font-size: 10px;
  color: #969696;
}
.book-info .book-introduction-wrap {
  color: #969696;
  padding: 6px 14.4px;
  font-size: 10px;
  line-height: 19.2px;
  text-align: left;
}

.read-history {
  background-color: #fff;
  margin-top: 12px;
}

.read-history .history-line {
  padding: 0 14.4px;
  line-height: 30px;
  height: 30px;
  border-bottom: 1px solid #f5f5f5;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  font-size: 12px;
}

.read-history .history-line .history-tit {
  color: #333;
}

.read-history .history-line .history-num {
  flex: 1;
  -webkit-flex: 1;
  padding: 0 6px;
  color: #ff6432;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.read-history .history-line .history-time {
  color: #333;
  font-size: 10px;
  padding-left: 6px;
}

.read-history .history-line .history-time.special {
  color: #ff6432;
}

.read-history .recommend {
  padding: 0 14.4px;
  display: block;
  line-height: 30px;
  height: 30px;
  color: #333;
}
.recommend {
  padding: 0 14.4px;
  display: block;
  line-height: 30px;
  height: 30px;
  color: #333;
  font-size: 12px;
  text-align: left;
}
.foot-wrap {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: rgba(83, 83, 83, 0.8);
  width: 100%;
  height: 34.4px;
  line-height: 34.4px;
  text-align: center;
}

.foot-wrap .foot-btn {
  flex: 1;
  -webkit-flex: 1;
  color: #fff;
  font-size: 12px;
}

.foot-wrap .foot-read {
  width: 129px;
  position: relative;
}

.foot-wrap .foot-read a {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  display: block;
  height: 44.5px;
  line-height: 40.8px;
  font-size: 15px;
  background-size: 100%;
  -webkit-background-size: 100%;
  color: #fff;
}
.book-info .read-record .read-last {
  padding: 0 8px;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  height: 40.5px;
  line-height: 40.5px;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #333;
  font-size: 14px;
  border-bottom: 1px solid #f0f0f0;
  justify-content: space-between;
}

.book-info .read-record .read-last .read-tit {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.book-info .read-record .read-last .read-tit i {
  font-style: normal;
  margin-right: 4.8px;
  color: #ff6432;
}

.book-info .read-record .read-last .read-tit i.read-new {
  color: #eebf64;
}

.book-info .read-record .read-last .arrowheadRight {
  width: 6px;
  padding-right: 10.5px;
}

.book-info .read-record .read-last .arrowheadRight img {
  width: 100%;
  display: block;
}

.discuss-wrap {
  width: 96%;
  background-color: #fff;
  margin: 6px auto;
  /* 移除固定高度，让内容自然撑开 */
  /* max-height: 400px; */
  /* overflow-y: auto; */
}

.discuss-wrap .discuss-line {
  height: 36px;
  line-height: 36px;
  border-bottom: 1px solid #f5f5f5;
  padding: 0 9px 0 7.5px;
  font-size: 9px;
  color: #666;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;
  justify-content: space-between;
}

.discuss-wrap .discuss-line .charge-frame {
  width: 28px;
  text-align: center;
  font-size: 12px;
  background-color: #f68c6d;
  color: #000;
  line-height: 11px;
  padding: 3.6px;
  color: #fff;
}

/* 新增样式 */
.load-more, .no-more, .no-chapters {
  text-align: center;
  padding: 10px;
  color: #969696;
  font-size: 12px;
}
</style>
